const toMobxFields = (fieldsProps) => Object.entries(fieldsProps).map(([name, fieldProps]) => {
    const observers = Array.isArray(fieldProps.observers) ? [...fieldProps.observers] : [];
    let output = null;
    let fields = null;
    let placeholder = null;
    let label = null;
    if (fieldProps.output) {
        output = fieldProps.output;
    }
    else if (Array.isArray(fieldProps.extra)) {
        output = value => value instanceof Object ? value.value : null;
    }
    else if (['text', 'email', 'phone', 'url', 'password'].some(type => type === fieldProps.type)) {
        output = value => value ? value : null;
    }
    else if (fieldProps.fields) {
        output = value => Object.values(value).every(v => !v) ? null : value;
    }
    if (fieldProps.fields) {
        fields = toMobxFields(fieldProps.fields);
    }
    if (fieldProps.placeholder !== '') {
        placeholder = `placeholder.${name}`;
    }
    if (fieldProps.label !== '') {
        label = `label.${name}`;
    }
    if (fieldProps.type === 'password' && name.includes('_confirmation')) {
        observers.push({
            key: 'value',
            call: ({ form, field }) => {
                form.$(field.path.replace('_confirmation', '')).validate({ showErrors: true });
            }
        });
    }
    return {
        ...fieldProps,
        name,
        output,
        fields,
        placeholder,
        label,
        observers
    };
});
const toFieldsNames = (fields) => {
    const fieldsNames = {};
    Object.entries(fields).forEach(([key, { fields }]) => {
        fieldsNames[key] = key;
        if (fields) {
            Object.assign(fieldsNames, toFieldsNames(fields));
        }
    });
    return fieldsNames;
};
export { toMobxFields, toFieldsNames };
